import axios from "axios";
// axiosConfig has no default export — importing it attaches the request/response
// interceptors to the global axios singleton (see mlsCandidatesApi for the same pattern).
import "../../utils/axiosConfig";
import { getAuthHeader } from "../../utils/authHeader";
import {
    MlsPreferencesResponse,
    MlsPropertyTypesResponse,
} from "../../types/mlsPropertyTypes";

const propertyTypesUrl = (): string =>
    `${process.env.REACT_APP_BACKEND_URL}/settings/mls-property-types`;

const preferencesUrl = (): string =>
    `${process.env.REACT_APP_BACKEND_URL}/settings/mls-preferences`;

// Combined MLS Agent Profile read: auto-sync toggle + catalog + selection in one call.
export const getMlsPreferences =
    async (): Promise<MlsPreferencesResponse> => {
        const headers = await getAuthHeader();
        const response = await axios.get<MlsPreferencesResponse>(
            preferencesUrl(),
            { headers, withCredentials: true },
        );
        return response.data;
    };

// Combined save: persist the toggle + property-type preference together.
export const updateMlsPreferences = async (
    autoIngestEnabled: boolean,
    propertyTypes: string[],
): Promise<MlsPreferencesResponse> => {
    const headers = await getAuthHeader();
    const response = await axios.patch<MlsPreferencesResponse>(
        preferencesUrl(),
        { autoIngestEnabled, propertyTypes },
        { headers, withCredentials: true },
    );
    return response.data;
};

// Catalog + the user's current auto-add selection in one call.
export const getMlsPropertyTypes =
    async (): Promise<MlsPropertyTypesResponse> => {
        const headers = await getAuthHeader();
        const response = await axios.get<MlsPropertyTypesResponse>(
            propertyTypesUrl(),
            { headers, withCredentials: true },
        );
        return response.data;
    };

export const updateMlsPropertyTypes = async (
    propertyTypes: string[],
): Promise<MlsPropertyTypesResponse> => {
    const headers = await getAuthHeader();
    const response = await axios.patch<MlsPropertyTypesResponse>(
        propertyTypesUrl(),
        { propertyTypes },
        { headers, withCredentials: true },
    );
    return response.data;
};
